import React from 'react';
import { Hero } from './components/Hero';
import { Hook } from './components/Hook';
import { Agitation } from './components/Agitation';
import { Revelation } from './components/Revelation';
import { Benefits } from './components/Benefits';
import { ValueStack } from './components/ValueStack';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { StickyCta } from './components/StickyCta';
export function App() {
  return <div className="w-full bg-cream font-sans" data-id="element-0" data-mp="2mmvlkvs92ic2">
      <Hero data-id="element-1" data-mp="2mjzlp1wudjkz" />
      <main data-id="element-2" data-mp="31aqeoda66opo">
        <Hook data-id="element-3" data-mp="31b8ka0iq2fa9" />
        <Agitation data-id="element-4" data-mp="31ayvgg9eye65" />
        <Revelation data-id="element-5" data-mp="31c9uy3vtszrg" />
        <Benefits data-id="element-6" data-mp="31ctfztgrw49p" />
        <ValueStack data-id="element-7" data-mp="2wk0bn6p7uxy5" />
        <Pricing data-id="element-8" data-mp="2wjgtppzkg9k4" />
        <Guarantee data-id="element-9" data-mp="2wiyuqllirh8i" />
        <Faq data-id="element-10" data-mp="2wip6b2g4hi4x" />
      </main>
      <footer className="w-full bg-plum-deep pb-28 pt-10 text-cream" data-id="element-11" data-mp="2wi5qbra193tj">
        <div className="mx-auto flex max-w-content flex-col gap-4 px-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-12" data-mp="28sl32w6ujkeg">
          <p className="font-display text-lg font-semibold" data-id="element-13" data-mp="23ti864kkyuk7">
            Kit Maestro de Evaluación Energética
          </p>
          <p className="font-sans text-sm text-cream/60" data-id="element-14" data-mp="3mlaxj7fckftz">
            Acceso digital inmediato · Soporte por mail
          </p>
        </div>
      </footer>
      <StickyCta data-id="element-15" data-mp="3rd1a7k1rbfok" />
    </div>;
}